import React from "react"
import { Tooltip, Typography } from "@material-ui/core"

import useStyles from "@/pages/Admin/TrackableLinks/TrackableLinkMetrics/TrackableLinkUTMMetrics/TrackableLinkUTMValue/styles"

type TrackableLinkUTMValueProps = {
	utmValue: string
}

const TrackableLinkUTMValue: React.FC<TrackableLinkUTMValueProps> = (props) => {
	const { utmValue } = props

	const classes = useStyles()

	return (
		<Tooltip title={utmValue}>
			<Typography
				variant="body1"
				className={classes.valueText}
			>
				{utmValue}
			</Typography>
		</Tooltip>
	)
}
export default TrackableLinkUTMValue
